export default __webpack_public_path__ + "static/media/ErrorIllustration.8feaf07a.png";